import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-badge-upper',
  templateUrl: './badge-upper.component.html',
  styleUrls: ['./badge-upper.component.scss'],
})
export class BadgeUpperComponent {
  @Input({ required: true }) text: string | number = '';
  @Input() variant: Variant = 'accent';
  @Input() size: Size = 'small';
}

type Variant = 'accent' | 'primary' | 'warn';

type Size = 'small' | 'medium' | 'large';
